module.exports = __webpack_public_path__ + "static/numer-pin-addad2d072b105f81169cb206520860a.jpg";